import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=2499cd9e&v-if=imageUrl&"
import script from "./ImagePopup.vue?vue&type=script&lang=ts&"
export * from "./ImagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports